// デザインボード：画面デザイン（.pen / OpenPencil）と業務フローボード（Excalidraw）。doc/design/pm-design-board-screens.html
export default {
  "design.tab": "Design",
  "design.page.entry": "Designs (whiteboard / .pen)",
  "design.page.title": "Designs",
  "design.page.titleOf": "{name} · Designs",
  "design.page.subtitle":
    "Organize flows with screenshots, sticky notes and arrows, and version and review them alongside .pen source files",
  "design.page.new": "New",
  "design.page.filteredByTask": "Showing designs for task “{name}” only",
  "design.page.showAll": "Show all",
  "design.empty": "No designs yet",
  "design.untitled": "Untitled flow board",
  "design.back": "Back to list",
  "design.more": "More",
  "design.retry": "Retry",
  "design.saved": "Saved as v{rev}",
  "design.col.title": "Title",
  "design.col.format": "Type",
  "design.col.task": "Linked task",
  "design.col.revision": "Rev",
  "design.col.updated": "Updated",
  "design.format.excalidraw": "Business flow",
  "design.format.pen": "Screen design",
  "design.deleteConfirm": "Delete “{title}”?",
  "design.deleteHint":
    "All revisions and review comments will be removed from the list.",
  "design.edit.title": "Edit design",
  "design.edit.taskHint": "Leave empty to make it a project-wide design.",
  "design.field.title": "Title",
  "design.field.titlePlaceholder":
    "Defaults to “Untitled whiteboard” or the file name",
  "design.field.task": "Linked task",
  "design.field.note": "Change note",
  "design.create.title": "Create design",
  "design.create.ok": "Create",
  "design.create.mode": "How to create",
  "design.create.blank": "Blank board",
  "design.create.file": "Import an .excalidraw file",
  "design.file.drop": "Drop a file here, or click to choose",
  "design.file.hint": ".excalidraw · up to {mb}MB (including images)",
  "design.file.need": "Please choose a file",
  "design.source.title": "Git origin (optional)",
  "design.source.hint":
    "Records where the file lives in Git. Do not enter credentials (URLs with tokens). Nothing is pulled or pushed automatically.",
  "design.source.repo": "Repository",
  "design.source.ref": "Branch / ref",
  "design.source.path": "Path in repository",
  "design.source.commitSha": "Commit SHA",
  "design.upload.menu": "Upload new version",
  "design.upload.title": "Upload new version (v{rev})",
  "design.upload.ok": "Import",
  "design.export.file": "Export file",
  "design.export.manifest": "Export metadata (.design.json)",
  "design.status.dirty": "Unsaved",
  "design.status.saving": "Saving…",
  "design.status.saved": "Saved",
  "design.status.error": "Save failed",
  "design.leave.title": "You have unsaved changes",
  "design.leave.content":
    "If you leave now, your unsaved changes will be lost.",
  "design.leave.ok": "Discard and leave",
  "design.conflict.title": "Someone else saved first",
  "design.conflict.content":
    "Your changes are still on screen. Loading the latest version will discard them. Save them as a separate design or download the draft first if needed.",
  "design.conflict.reload": "Load latest (discard my changes)",
  "design.conflict.keep": "Back to editor",
  "design.conflict.saveAsCopy": "Save my changes as a separate design",
  "design.conflict.copyTitle": "{title} (conflict copy)",
  "design.conflict.download": "Download draft (.excalidraw)",
  "design.history.banner": "Viewing v{rev} (read-only; latest is v{latest})",
  "design.history.latest": "Back to latest",
  "design.history.restore": "Restore this revision",
  "design.restore.note": "Restored from v{rev}",
  "design.pen.limitTitle":
    "Viewing and editing .pen in the browser is not supported yet",
  "design.pen.limitBody":
    "The original file is stored and exported byte-for-byte. Embedding the native OpenPencil canvas and lossless write-back have not been verified, so they are not offered. Edit with the steps below.",
  "design.pen.file": "File name",
  "design.pen.size": "Size",
  "design.pen.download": "Download .pen",
  "design.pen.step1": "Download the original with “Download .pen”",
  "design.pen.step2":
    "Open and edit it in OpenPencil or another .pen-capable tool",
  "design.pen.step3":
    "Upload it with “Import a new revision from file” (rejected if someone else has already added a newer revision)",
  "design.comment.title": "Review",
  "design.comment.scopeRev": "v{rev}",
  "design.comment.scopeAll": "All revisions",
  "design.comment.none": "No comments yet",
  "design.comment.loadFailed": "Could not load comments",
  "design.comment.placeholder": "Comment on v{rev}",
  "design.comment.post": "Comment",
  "design.comment.empty": "Please enter a comment",
  "design.comment.resolved": "Resolved",
  "design.comment.resolvedBy": "Resolved by {name}",
  "design.comment.deleteConfirm": "Delete this comment?",
  "design.task.openList": "Open design board",
  "design.error.load": "Could not load the design",
  "design.error.notFound":
    "Design not found (deleted, or you do not have access)",
  "design.error.parse":
    "The stored content cannot be read as a whiteboard. Editing is disabled to avoid overwriting it.",
  "design.error.save": "Could not save",
  "design.error.network":
    "Cannot reach the server. Your changes are still on screen.",
  "design.error.size":
    "Too large (up to 10MB including images). Shrink or remove some images",
  "design.error.elements": "Too many elements (up to 5000)",
  "design.error.embeddable":
    "Web embed elements cannot be saved. Remove them and save again",
  "design.error.image-missing":
    "Image data is missing. Paste the image again and save",
  "design.error.image-type":
    "This image type cannot be saved (PNG / JPEG / GIF / WebP only)",
  "design.error.image-size": "Image too large (up to 5MB each)",
  "design.error.type": "Please choose an .excalidraw or .pen file",
  "design.error.format": "This file is a different type from this design",
  "design.close": "Close",
  "design.frame.status.draft": "Draft",
  "design.frame.status.review": "In review",
  "design.frame.status.changes": "Changes requested",
  "design.frame.status.approved": "Approved",
  "design.frame.list": "Screens",
  "design.frame.panel": "Tasks & review",
  "design.frame.search": "Search screens",
  "design.frame.collapse": "Hide screens",
  "design.frame.expand": "Show screens",
  "design.frame.none": "No screens (top-level frames)",
  "design.frame.reviewStatus": "Review status",
  "design.frame.tasks": "Linked tasks",
  "design.frame.unlink": "Unlink",
  "design.frame.linkTask": "+ Link a task",
  "design.frame.notInLatest":
    "This screen is not in the latest version (status and tasks belong to latest screens)",
  "design.frame.removed": "Removed in latest",
  "design.pen.historyBanner":
    "Viewing v{rev} (latest v{latest}). Status and tasks show current values",
  "design.pen.missingFonts":
    "Some fonts could not be loaded and were substituted: {fonts}",
  "design.pen.viewerError": "Could not display this .pen",
  "design.pen.loading": "Loading in OpenPencil…",
  "design.pen.selectHint":
    "Click a screen to set review status, tasks and comments. Edit the .pen in Pencil and upload it as a new version",
  "design.pen.uploaded": "Uploaded v{rev}",
  "design.board.frames": "{n} screens",
  "design.board.filter.all": "All",
  "design.board.newPen": "Screen design (.pen)",
  "design.board.newPenHint": "Upload a .pen to view and review in OpenPencil",
  "design.board.newFlow": "Business flow board",
  "design.board.newFlowHint":
    "Map the flow with screens, notes and arrows (Excalidraw)",
  "design.board.empty":
    'No design boards yet. Upload a .pen or create a business flow board from "New"',
  "design.create.penTitle": "Upload screen design (.pen)",
  "design.create.boardTitle": "Create business flow board",
  "design.create.penHint":
    "The .pen made in Pencil is stored as-is and shown in OpenPencil (editing .pen in the browser is not supported)",
  "design.file.hintPen": ".pen · up to {mb}MB",
  "design.flow.add": "Add screens",
  "design.flow.addTitle": "Add screens to the flow board",
  "design.flow.addOk": "Add {n}",
  "design.flow.pickNeed": "Select screens to add",
  "design.flow.pickAll": "Select all",
  "design.flow.renderFailed": "Could not render the screens.",
  "design.flow.noPen": "This project has no screen design (.pen) yet",
  "design.flow.renderHint":
    "Images are rendered by OpenPencil in your browser. Status and tasks are shared with the screen design",
  "design.flow.added": "Added {n} screens (save to keep them)",
  "design.flow.refreshed": "Updated to v{rev} (save to keep it)",
  "design.flow.source": "Source: {design} · v{rev}",
  "design.flow.outdated": "A newer version v{rev} of the screen design exists",
  "design.flow.refresh": "Update to v{rev}",
  "design.flow.frameGone":
    "The source screen was not found (it may have been removed)",
  "design.flow.shared": "shared with screen design",
  "design.flow.openDesign": "Open in screen design",
  "design.task.empty": "No screens or flow boards are linked to this task",
};
